import logo from "../../../../public/projects/Mantra/images/logo/logo.png";
import codename from "../../../../public/projects/Mantra/images/projects/Codename.jpg";
import Joypin from "../../../../public/projects/Mantra/images/projects/Joypin.jpg";
import one from "../../../../public/projects/Mantra/images/projects/one.jpg";
import riverside from "../../../../public/projects/Mantra/images/projects/riverside.jpg"
// Mantra Properties
import overviewImage_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Overview/1.webp";
import bannerDesktopImage_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Banner/1.webp";
import bannerMobileImage_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Banner/2.webp";
import siteVisitBannerImage_one_resideces from "../../../../public/projects/Mantra/images/one_residences/SiteVisitBanner/1.webp";
import Location_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Location/L1.webp";
import Hightlights_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Highlights/1.webp";
import floorplan1_one_resideces from "../../../../public/projects/Mantra/images/one_residences/floorplan/1.webp";
import floorplan2_one_resideces from "../../../../public/projects/Mantra/images/one_residences/floorplan/2.webp";
import floorplan3_one_resideces from "../../../../public/projects/Mantra/images/one_residences/floorplan/3.webp";
import floorplan4_one_resideces from "../../../../public/projects/Mantra/images/one_residences/floorplan/4.webp";
import locationicon_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Overview/l.png";
import calicon_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Overview/c.png";
import newlaunchicon_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import gallery1_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Gallery/1.webp";
import gallery2_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Gallery/2.webp";
import gallery3_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Gallery/3.webp";
import gallery4_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Gallery/4.webp";
import gallery5_one_resideces from "../../../../public/projects/Mantra/images/one_residences/Gallery/5.webp";

export const developersMantra = {
  properties: [
    {
      name: "Mantra - Joypin ",
      image:Joypin,
      price: "On Request",
      location: "Kharadi, Pune",
      projectlocation: "East Pune",
      bed: "2 - 3 BHK",
      state: "Pune",
      developer: "Mantra",
      size: "840 - 1200 sq.ft.",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Mantra - Riverside",
      image: riverside,
      price: "On Request",
      location: "Balewadi, Pune",
      projectlocation: "East Pune",
      state: "Pune",
      developer: "Mantra",
      bed: "2 -3 - 4 BHK Apartments",
      size: "On Request",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Mantra - One Residenses",
      image: one,
      price: "On Request",
      location: "Magarpatta, Pune",
      projectlocation: "East Pune",
      state: "Pune",
      developer: "Mantra",
      bed: "3 - 4 BHK Apartments",
      size: "On Request",
      url: `/mantra-one-residences-magarpatta-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "2007",
  },
  about: `With its headquarters located in Pune, Mantra is a well-known real estate developer known for its creative approach to creating high-end residential and commercial projects. With over 17 years of experience, the brand has established a distinguished reputation for delivering projects on time while maintaining an unmatched focus on quality. Mantra's portfolio, which includes 12 completed projects and 18 ongoing developments, is evidence of its dedication to excellence across a variety of real estate segments. Known as "The Gold of Modern Luxury," Mantra plans to launch new luxurious ventures in 2025, further solidifying its prestigious position in the real estate market.

`,
};

export const projectsMantra = {
  one_resideces: {
    bannerdata: {
      bannerDesktopImage:bannerDesktopImage_one_resideces,
      bannerMobileImage:bannerMobileImage_one_resideces,
      textOverlay: "",
      data: {
        title: "Mantra One Residences",
        subtitle: "Magarpatta, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano:"P52100066482",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Mantra 1 Residences ",
      description: [
        "Mantra 1 Residences, the crown jewel of Mantra Burgundy – The Luxury Line, redefines upscale living with elegance and sophistication. This prestigious township project offers a seamless blend of beauty, comfort, and convenience, designed for discerning homebuyers. Crafted with precision, it stands as a modern architectural marvel, elevating everyday living to new heights. ",
        "Featuring world-class amenities and impeccable design, Mantra 1 Residences promises a refined lifestyle with unmatched luxury. From exquisite interiors to thoughtfully planned spaces, this premium residential destination ensures a seamless fusion of style and functionality, making it the perfect choice for those who seek the extraordinary.",
      ],
      image: overviewImage_one_resideces,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_one_resideces,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_one_resideces,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_one_resideces,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_one_resideces,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1464 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK + Ultima ",
          area: "1696 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK ",
          area: "1873 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK + Ultima ",
          area: "2087 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
          area: "1464 sq. ft.",
          price: "On Request*",
        image: floorplan1_one_resideces,
      },
      {
        type: "3 BHK + Ultima ",
          area: "1696 sq. ft.",
          price: "On Request*",
        image: floorplan2_one_resideces,
      },
      {
        type: "4 BHK ",
          area: "1873 sq. ft.",
          price: "On Request*",
        image: floorplan3_one_resideces,
      }, 
       {
        type: "4 BHK + Ultima ",
          area: "2087 sq. ft.",
          price: "On Request*",
        image: floorplan4_one_resideces,
      },
      
    ],

    highlights: {
      images: Hightlights_one_resideces,
      tagline: "Highlights",
      features: [
        "Resort like Amenities.",
        "70% open spaces.",
        "1 lac sq.ft of Landscaping.",
        "World-renowned design partners",
        "5 Star Hospitality services.",
      ],
    },

    location: {
      image: Location_one_resideces,
      data:[
        {
          airport:{
            distance_time:"9 km",
            name:"Pune Airport"
          },
          school:{
            distance_time:"1 Km",
            name:"Intervidajagriti "
          },
          railwayormetro:{
            distance_time:"16 Km",
            name:"Pune Station"
          },
          hospital:{
            distance_time:"6 Km",
            name:" M S Hospital"
          },
          mall:{
            distance_time:"1 Km",
            name:"Seasons Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_one_resideces },
        { image: gallery2_one_resideces },
        { image: gallery3_one_resideces },
        { image: gallery4_one_resideces },
        { image: gallery5_one_resideces },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Mantra 1 Residences , kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is Mantra 1 Residences located?",
        answer: `The project is situated in Magarpatta, Pune, a prime location known for its IT hubs, commercial centers, and seamless connectivity to major parts of the city.`,
      },
      {
        question: "What are the available configurations in Mantra 1 Residences?",
        answer: `Mantra 1 Residences offers 3 BHK and 4 BHK apartments designed with contemporary architecture and premium specifications.`,
      },
      {
        question: "What is the starting price of apartments in Mantra 1 Residences?",
        answer: `The starting price of apartments in Mantra 1 Residences varies based on configuration and availability. Please contact our sales team for the latest pricing.`,
      },
      {
        question: "Who is the developer of Mantra 1 Residences?",
        answer: `Mantra 1 Residences is developed by Mantra Properties, a reputed real estate developer known for delivering quality projects in Pune.`,
      },
      {
        question: "What amenities are available at Mantra 1 Residences?",
        answer: `The project offers a range of amenities, including a clubhouse, gymnasium, landscaped gardens, swimming pool, kids’ play area, and 24/7 security.`,
      },
      {
        question: "Is Mantra 1 Residences RERA registered??",
        answer: `Yes, the project is RERA registered. The RERA registration ensures transparency and adherence to regulatory guidelines.`,
      },
      {
        question: "What makes Mantra 1 Residences, Magarpatta, Pune a standout choice for homebuyers?",
        answer: `Mantra 1 Residences in Magarpatta, Pune, stands out as a prime choice for homebuyers due to its strategic location, modern design, and premium amenities. `,
      },
      {
        question: "What is the possession date for Mantra 1 Residences?",
        answer: `The expected possession date for Mantra 1 Residences is yet to be officially announced. It is advisable to check with the developer for updates.`,
      },
      {
        question: "How well is Mantra 1 Residences connected to key locations in Pune?",
        answer: `The project enjoys excellent connectivity to major IT parks, commercial hubs, shopping centers, hospitals, and schools via well-developed road networks.`,
      },
      {
        question: "Are there any schools and hospitals near Mantra 1 Residences?",
        answer: `Yes, reputed schools and hospitals, including Magarpatta City Public School and Noble Hospital, are in close proximity to the project.`,
      },
    ],

    similar :{
      properties: [
        {
          name: "Mantra - Joypin ",
          image:Joypin,
          price: "On Request",
          location: "Kharadi, Pune",
          projectlocation: "East Pune",
          bed: "2 - 3 BHK",
          state: "Pune",
          developer: "Mantra",
          size: "840 - 1200 sq.ft.",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Mantra - Riverside",
          image: riverside,
          price: "On Request",
          location: "Balewadi, Pune",
          projectlocation: "East Pune",
          state: "Pune",
          developer: "Mantra",
          bed: "2 -3 - 4 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Mantra - One Residenses",
          image: one,
          price: "On Request",
          location: "Magarpatta, Pune",
          projectlocation: "East Pune",
          state: "Pune",
          developer: "Mantra",
          bed: "3 - 4 BHK Apartments",
          size: "On Request",
          url: `/mantra-one-residences-magarpatta-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
    
  },
}
